import React from "react";
import { Zap, Sparkles, MessageCircle, Images, Camera, Trophy, Star } from "lucide-react";

const MAP = {
  legend: { icon: Trophy, cls: "border-amber-400/50 text-amber-300 bg-amber-400/10" },
  top_voter: { icon: Zap, cls: "border-amber-400/50 text-amber-300 bg-amber-400/10" },
  power_voter: { icon: Zap, cls: "border-primary/50 text-primary bg-primary/10" },
  tastemaker: { icon: Star, cls: "border-fuchsia-400/40 text-fuchsia-300 bg-fuchsia-400/10" },
  conversationalist: { icon: MessageCircle, cls: "border-sky-400/40 text-sky-300 bg-sky-400/10" },
  curator: { icon: Images, cls: "border-emerald-400/40 text-emerald-300 bg-emerald-400/10" },
  contributor: { icon: Camera, cls: "border-border text-muted-foreground" },
  creator: { icon: Camera, cls: "border-primary/50 text-primary bg-primary/10" },
};

export const Badges = ({ badges, editable, onToggle }) => {
  const list = editable ? badges : (badges || []).filter((b) => !b.hidden);
  if (!list || list.length === 0) return null;
  return (
    <div className="mt-3" data-testid="profile-badges">
      {editable && <p className="text-xs text-muted-foreground mb-1.5">Tap a badge to show/hide it on your public profile.</p>}
      <div className="flex flex-wrap gap-2">
        {list.map((b) => {
          const m = MAP[b.key] || { icon: Sparkles, cls: "border-border text-muted-foreground" };
          const Icon = m.icon;
          const dim = editable && b.hidden;
          return (
            <button key={b.key} data-testid={`badge-${b.key}`} onClick={editable ? () => onToggle(b.key) : undefined}
              disabled={!editable}
              className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border transition-all ${m.cls} ${dim ? "opacity-35 line-through" : ""} ${editable ? "cursor-pointer hover:scale-105" : "cursor-default"}`}>
              <Icon className="w-3.5 h-3.5" /> {b.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
